module.exports = __webpack_public_path__ + "@/assets/img/video.ee2ba596.svg";